import {
  addCbu,
  addDni,
  addExtra,
  addLibretaVacunacion,
} from '../axios/Reintegro/Documentacion';

export const isDocumentacionCompleta = (doc) => {
  if (!doc) return false;

  const hasAdj = (d) => !!d?.archivo_adjunto_id;

  const hasConstancia = () =>
    hasAdj(doc.constancia) ||
    doc.otros?.some((o) => o.label === 'constancia' && hasAdj(o));

  // Obligatorios
  if (!hasAdj(doc.dniFrente) || !hasAdj(doc.dniDorso) || !hasAdj(doc.libretaVacunacion)) {
    return false;
  }

  return hasAdj(doc.cbu) || (hasConstancia() && hasAdj(doc.terceroCbu));
};

export const TYPE_MAP: Record<string, string> = {
  dni_frente: 'dni',
  dni_dorso: 'dni',
  cbu: 'file',
  tercero_cbu: 'file',
  libreta_vacunacion: 'libreta_vacunacion',
  constancia: 'doc_extra',
};

const addDniSide = (lado: 'frente' | 'dorso') => (fd: FormData) => {
  fd.append('lado', lado);
  return addDni(fd);
};

export const DOCUMENT_HANDLERS = {
  dni_frente: addDniSide('frente'),
  dni_dorso: addDniSide('dorso'),
  cbu: addCbu,
  tercero_cbu: addCbu,
  libreta_vacunacion: addLibretaVacunacion,
  constancia: addExtra,
};
